import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV1120({ createThumbnail }) {
  return (
    <ReleaseCard version="v1.12.0" date="12th October 2026"
        title="Share the action, invite your crew & never lose your game!">
      <p className="text-gray-300 mb-4">This release is packed with ways to bring people into the game and keep you connected to the action. Here's everything that's new:</p>
      <div className="mb-6">
        <h5 className="text-lg font-medium text-purple-400 mb-2">Invite Codes</h5>
        <p className="text-gray-300 mb-4">
          Joining a private venue just got effortless. Your host shares a code, you type it in — done. No GPS, no searching, no hassle. Perfect for online leagues or venues you can't physically visit.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Share Your Game Instantly</h5>
        <p className="text-gray-300 mb-4">
          As soon as a game kicks off you can share it with friends in one tap. Send a link via WhatsApp, text, or wherever your group hangs out and get everyone to the table faster.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Shareable & Editable Game Reports</h5>
        <p className="text-gray-300 mb-4">
          Game reports can now be shared with a single link — great for settling debates or showing off a big win. Need to fix a typo or adjust a result? You can edit reports after the game too.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Your Quick Game Stays Put</h5>
        <p className="text-gray-300 mb-4">
          No more hunting for your game. Quick games now stay pinned to the Home screen so you can jump straight back in whenever you need to — even after switching apps or locking your phone.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Better Photos</h5>
        <p className="text-gray-300 mb-4">
          Game and winner photos have been upgraded with higher quality images and a cleaner presentation, so your victories look as good as they feel.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Bigger Blinds on the Lock Screen</h5>
        <p className="text-gray-300 mb-4">
          Blind levels are now larger and easier to read at a glance on the lock screen — no need to unlock or squint across the table.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Smoother Navigation & Refreshed Game Screen</h5>
        <p className="text-gray-300 mb-4">
          Club navigation is snappier, and the in-game screen has been refreshed for a cleaner, more intuitive layout while you play.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Rock-Solid Reconnection</h5>
        <p className="text-gray-300 mb-4">
          Dropped connections are handled more gracefully than ever. If the server is unreachable you'll see a clear status message instead of wondering what happened.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Bug Fixes & Performance</h5>
        <p className="text-gray-300 mb-4">
          Under-the-hood tweaks and fixes to keep everything running fast and smooth.
        </p>
      </div>
    </ReleaseCard>
  );
}
